<script lang="ts">
    import { writable } from 'svelte/store';
    import { setMousePositionContext } from '$lib/context.js';

    const mousePosition = writable({ x: 0, y: 0 });
    setMousePositionContext(mousePosition);
</script>

<svelte:window
    on:mousemove|passive={(e) => {
        if (!('ontouchstart' in document.documentElement)) {
            $mousePosition = {
                x: Math.round(((e.clientX / window.innerWidth) * 2 - 1) * 1000) / 1000,
                y: Math.round(((e.clientY / window.innerHeight) * 2 - 1) * 1000) / 1000
            };
        }
    }}
/>

<div style="--mouse-x: {$mousePosition.x.toFixed(3)}; --mouse-y: {$mousePosition.y.toFixed(3)}">
    <slot />
</div>
